<template>
    <div class="order">
		<div class="page-tit mr0">
			<span>文章管理</span>
		</div>
        <div class="home-teble" style="padding: 24px;">
            <div style="display: flex; justify-content: flex-end; align-items: center; margin-bottom: 12px;">
                <div class="search-for">
                    <el-input placeholder="请输入文章类型搜索" v-model="userName" @keyup.enter.native="getListFn(1)"></el-input>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <el-input placeholder="请输入关键字搜索" v-model="title" @keyup.enter.native="getListFn(1)">
                        <el-button size="small" slot="append" @click="getListFn(1)">搜索</el-button>
                    </el-input>
                </div>

                <div style="margin-right: 12px;">已选择 {{getCheckedIds().length}} 项</div>
                <el-button size="mini" @click="infoList.forEach(val => val.checked = true)">全选</el-button>
                <el-button size="mini" @click="infoList.forEach(val => val.checked = !val.checked)">反选</el-button>
                <el-button type="success" size="mini" @click="showPublishFn(getCheckedIds())">批量发布</el-button>
                <el-button size="mini" @click="$router.push({name: 'siteAddContent'})" type="primary">新增文章</el-button>
            </div>
			<el-table :data="infoList" style="width: 100%">
                <el-table-column type="index" label=" " align="center" width="60">
                    <template slot-scope="scope"><el-checkbox v-model="scope.row.checked"></el-checkbox></template>
                </el-table-column>
				<el-table-column prop="imgUrl"  label="缩略图" width="135">
                    <template slot-scope="scope">
                        <img v-if="scope.row.imgUrl" style="border-radius: 3px;" :src="scope.row.imgUrl" alt="" width="80" height="60">
                        <span v-else>暂无缩略图</span>
                    </template>
                </el-table-column>
				<el-table-column prop="prodTitle" label="标题"></el-table-column>
				<el-table-column prop="keywords" label="关键词" ></el-table-column>
				<el-table-column prop="source" label="来源" width="80">
                    <template slot-scope="scope">
                        {{scope.row.source === 'YC' ? '原创' : scope.row.source === 'ZQ' ?'抓取' : '其他'}}
                    </template>
                </el-table-column>
				<el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <span :class="{'success': scope.row.status === '1'}">{{scope.row.status === '0' ? '待发布' : '已发布'}}</span>
                    </template>
                </el-table-column>
				<el-table-column prop="type" label="文章类型" width="80">
                    <template slot-scope="scope">
                        {{scope.row.userName || '-'}}
                    </template>
                </el-table-column>
				<el-table-column prop="releaseTime"  label="创建时间" width="160"></el-table-column>
				<el-table-column  label="操作" width="180">
					<template slot-scope="scope">
						<el-button type="text" @click="showDeleteFn(scope.row.id)" style="color: #FF4949;">删除</el-button>
						<el-button type="text" @click="$router.push({name: 'siteAddContent', query: {id: scope.row.id}})">修改</el-button>
						<el-button type="text" @click="showPublishFn([scope.row.id])" v-if="scope.row.status === '0'">发布</el-button>
						<el-button type="text" @click="showPublishFn([scope.row.id])" v-else>再次发布</el-button>
					</template>
				</el-table-column>
			</el-table>
            <div style="display: flex; justify-content: flex-end;">
                <el-pagination background layout="prev, pager, next, jumper" :page-size="pageSize" @current-change="handleCurrentChange" :total="total"></el-pagination>
                <el-select v-model="pageSize" size="mini" placeholder="每页条数" style="width: 100px; margin-left: 24px; margin-top: 32px;" @change="getListFn()">
                    <el-option v-for="item in [10, 20, 40, 60]" :key="item" :label="item + '篇/页'" :value="item"></el-option>
                </el-select>
            </div>
		</div>
        <yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
        <!-- 发布确认弹窗 -->
        <el-dialog title="请选择发布站点和分类" :visible.sync="publishDialog" width="640px">
            <div style="width: 100%;position: relative;" v-loading="publishLoading">
                <div class="cur" style="position: absolute; top: 0; right: 0;" @click="getZsInfoFn">
                    <i class="el-icon-refresh"></i>
                    刷新站点
                </div>
                <ZsProjectEdit v-if="publishDialog" :value="publishData.projList" :detailId="'add'" :zsList="zsList"></ZsProjectEdit>
                <div class="proj-list">
                    <div class="content-value">
                        <div class="table" style="width: 145px; text-align: left;">发布时间</div>
                        <div class="content-value-main" style="width: calc(100% - 210px); text-align: left;">
                            <el-date-picker
                                class="height32"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-model="publishData.releaseTime"
                                type="datetime"
                                placeholder="选择日期时间"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="publishFn()">确认发布</el-button>
                <el-button @click="publishDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SiteApi from '@/api/site.api'
import mixinDialog from '@/mixins/mixinsDialog'
import ZsProjectEdit from './ZsProjectEdit.vue'
import moment from 'moment'

export default {
    name: 'AiteNetworkList',
    mixins: [mixinDialog],
    components: {
        ZsProjectEdit
    },
    data() {
        return {
            title: '',
            loading: false,
            infoList: [],
            pageNum: 1,
            pageSize: 10,
			total: 0,
            deleteId: '',
            userName: '',
            // 发布数据
            publishDialog: false,
            publishLoading: false,
            publishData: {
                id: '',
                releaseTime: '',
                projList: [{projId: '', pageId: ''}],
            },
            // 公司信息
            enterpriseData: {},
            // 站点列表
            zsList: [],
        }
    },
    methods: {
        ...mapActions('user', [
			'getEnterpriseInfo',
		]),
        // 获取列表
        getListFn(num) {
            if (!this.siteContent) return
            if (num) {
                this.pageNum = num
            }
            this.loading = true
            SiteApi.getSiteArticleDetail({
                companyId: this.enterpriseData.enterpriseId,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                prodTitle: this.title,
                userName: this.userName
            }).then(res => {
                if (res.data.isSuccess && res.data.data) {
                    this.infoList = res.data.data.list.map(item => ({
                        ...item,
                        checked: false
                    }))
                    this.total = res.data.data.total
                    this.loading = false
                } else {
                    this.openErrDialog('warn', '操作信息提示', '', '', '获取文章列表失败，请稍后重试', '确定')
                }
            })
        },
        // 分页
        handleCurrentChange (val, pageSize) {
			this.pageNum = val
			// this.pageSize = pageSize
			this.getListFn(0)
		},
        deleteFn() {
            SiteApi.deleteSiteArticle(this.deleteId).then(res => {
                const data = JSON.parse(res.data.data)
                if (res.data.isSuccess) {
                    if (data.isSuccess) {
                        this.$message.success('删除文章成功')
                        this.getListFn(0)
                    } else {
                        this.$message.error(data.message || '删除文章失败，请稍后重试')
                    }
                }
            })
        },
        // 删除
        showDeleteFn(id) {
            this.deleteId = id
            this.openErrDialog('warn', '操作信息提示', 'deleteFn', '', '确认删除该文章吗？', '确定', '取消')
        },
        // 发布接口
        publishFn() {
            if (!this.siteContent) return
            if (this.publishLoading) return
            if (!this.publishData.releaseTime) {
                this.openErrDialog('warn', '操作信息提示', '', '', '请选择发布时间', '确定')
                return
            }
            if (!this.publishData.projList.length) {
                this.openErrDialog('warn', '操作信息提示', '', '', '请选择发布站点和分类', '确定')
                return
            }
            if (!this.publishData.projList.every(item => item.projId && item.pageId)) {
                const index = this.publishData.projList.findIndex(item => !item.projId || !item.pageId)
                this.openErrDialog('warn', '操作信息提示', '', '', `请选择【网站${index + 1}】发布站点和分类`, '确定')
                return
            }
            this.publishLoading = true
            SiteApi.publishSiteArticle({
                data: this.publishData.projList,
                id: this.publishData.id,
                releaseTime: this.publishData.releaseTime
            }).then(res => {
                this.publishLoading = false
                this.publishDialog = false
                if (res.data.isSuccess) {
                    this.$message.success(res.data.message || '发布文章成功')
                    this.getListFn(0)
                } else {
                    this.$message.error(res.data.message || '发布文章失败，请稍后重试')
                }
            })
        },
        // 发布
        showPublishFn(ids) {
            if (!this.siteContent) return
            if (!ids.length) {
                this.openErrDialog('warn', '操作信息提示', '', '', '请选择要发布的文章', '确定')
                return
            }
            this.publishData = {
                id: ids,
                releaseTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                projList: [{projId: '', pageId: ''}],
            }
            this.publishDialog = true
        },
        //获取公司信息
		getInfos () {
			this.getEnterpriseInfo().then(res => {
				if (res.data.isSuccess) {
					const data = res.data.data
					this.enterpriseData = data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
                this.getListFn(1)
			})
		},
        getZsInfoFn() {
            let This = this
            This.publishLoading = true
            SiteApi.getSiteList({
                UId: this.userInfo.id, mobile: this.userInfo.moblie
            }).then(res => {
                This.publishLoading = false
                if (res.data.isSuccess) {
                    This.zsList = res.data.data
                } else {
                    This.$message({ message: '站点获取失败！', type: 'warning' })
                }
            })
        },
        // 获取选中的id
        getCheckedIds() {
            return this.infoList.filter(item => item.checked).map(item => item.id)
        },
        submitForm(data) {
            data.userName = '生物'
            SiteApi.editSiteArticle(data).then(res => {
                if (res.data && res.data.isSuccess) {
                    this.$message.success(res.data.message || '保存成功')
                } else {
                    this.$message.error(res.data.message || '保存失败，请稍后重试')
                }
            })
        }
    },
    created () {
        this.getInfos()
        this.getZsInfoFn()
    },
    computed: {
		...mapGetters('user', ['userInfo']),
        siteContent () {
			return localStorage.getItem('SITE_CONTENT') && localStorage.getItem('SITE_CONTENT') === 'true'
		}
	},
}
</script>
<style scoped lang="scss">
    .search-for {
        display: flex;
        height: 30px;
        margin-right: auto;
        span {
            border: 0;
            line-height: 20px;
        }
    }
    .home-teble{
		padding: 40px 18px;
		background:#fff;
		border-radius: 4px;
		.has-gutter{
			height: 40px;
			background-color: #f7f9fc;
			border: solid 1px #eeeeee;

		}
		.el-table{
			border-radius: 4px;
			border:1px solid rgba(221,223,230,1);
		}
	}
    .success{
        color: green;
    }
</style>
